export default "__VITE_ASSET__DUsoM7BW__"